export const classes = {
  stickyCell: 'sticky left-0 bg-grey-1',
};
